import { PreviewsContext } from "contexts/MightyTool";
import { useContext } from "react";
const usePreviews = () => useContext(PreviewsContext);
export default usePreviews;
